



























/* Created- 23 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FacetInfo, ListItemDTO } from "../../../Generated/ParticaAPI";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";

@Component(
	{
		name: "SearchFacets",
		components: { ParticaRowContainer }
	})
export default class SearchFacets extends Vue {
	@Prop() private facetResults: FacetInfo[];
	@Prop() private filters: { [key: string]: string; };

	private getName(facet: string): string {
		switch (facet.toLowerCase()) {
			case "articledate": {
				return "Article Date";
			}
			case "article_type": {
				return "Article Type";
			}
			case "syndicationtags": {
				return "Tags";
			}
			case "themes": {
				return "Country";
			}
			default: {
				return facet;
			}
		}
	}

	private selected(item: FacetInfo, selected: string, event: any) {
		// tslint:disable-next-line
		this.$emit("partica-event", { action: eParticaAction.SEARCH_FACET_UPDATE, item: { checked: event, facetName: item.facetName, value: selected } } as ParticaEvent);
	}
}
